export const menuItems = [
/*    {
        id: 1,
        label: 'menuitems.dashboards.text',
        icon: 'bx-home-circle',
        link: '/'
    },*/
    {
        id: 2,
        label: "menuitems.users.text",
        icon: "bx-user-circle",
        link: "/users"
    },
    {
        id: 3,
        label: "menuitems.pages.text",
        icon: "bx-book-open\n",
        link: "/pages/list"
    },
    {
        id: 4,
        label: "menuitems.inventories.text",
        icon: "bx-hash",
        subItems: [
            {
                label: "menuitems.inventories.negatives",
                link: "/inventories/list",
            },
            {
                label: "menuitems.inventories.drawings",
                link: "/drawings/list"
            },
        ]
    },
    {
        id: 5,
        label: "menuitems.persons.text",
        icon: "bx-group",
        link: "/persons/list"
    },/*
    {
        id: 6,
        label: "menuitems.locations.text",
        icon: "bx-map-pin",
        link: "/locations/list"
    },*/
    {
        id: 7,
        label: "menuitems.correspondences.text",
        icon: "bx-transfer",
        link: "/correspondences/list"
    },
    {
        id: 8,
        label: "menuitems.newspapers.text",
        icon: "bx-news",
        link: "/newspapers/grid"
    },
    {
        id: 9,
        label: "menuitems.notebooks.text",
        icon: "bx-book-content",
        link: "/notebooks/grid"
    }
];

